const i = ({
  permission: e,
  component: t,
  role: s
}) => s.permissions.some(
  (n) => n.name === e && n.component === t
), m = ({ roles: e, permissionNames: t, component: s, objectId: n }) => {
  const c = e == null ? void 0 : e.find((r) => r.scope.object_id === n);
  return c ? t.every((r) => i({ role: c, permission: r, component: s })) : !1;
}, o = ({ objectId: e, permissionNames: t, roles: s, component: n }) => e ? m({
  roles: s,
  permissionNames: t,
  component: n,
  objectId: e
}) : t.every(
  (c) => s.some((r) => i({ role: r, permission: c, component: n }))
);
export {
  o as getUserHasPermissions
};
//# sourceMappingURL=getUserHasPermissions.js.map
